import { useIdentificationCardList } from "Hooks/Options/useIdentificationCardList";
import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { Dropdown } from "../Dropdown";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  name: FieldPath<FormType>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  label?: string;
  disabled?: boolean;
};

export const IdentificationCardDropdown = <T extends object, V extends object>({
  control,
  name,
  label,
  disabled,
}: Props<T, V>) => {
  const { identificationCards } = useIdentificationCardList();

  return (
    <Dropdown
      codeList={identificationCards}
      name={name}
      control={control}
      label={label}
      disabled={disabled}
    />
  );
};
